<loading [loading]="loading" [loadingMessage]="loadingMessage"></loading>

<ng-container *ngIf="!loading">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger error-wrapper">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>

  <div
    *ngIf="sending_bulk_invite == true"
    class="alert alert-warning alert-dismissible fade show"
    role="alert"
  >
    <strong>Sending out invites in progress!</strong>
    Updated invites will be available once all the document invites are sent. To check if the app is still
    sending out invites, refresh this page.
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <section class="sn-panel" [ngStyle]="{ 'max-height.px': status_height }" #snPanel>
    <div class="status-heading">
      <div class="left">
        <div class="switch">
          <span class="switch__label" [ngClass]="{ active: !is_show_logs }" (click)="is_show_logs = false"
            >Statuses</span
          >
          <span class="switch__label" [ngClass]="{ active: is_show_logs }" (click)="is_show_logs = true"
            >Bulk Invite Logs</span
          >
          <div class="switch__substrate" [ngClass]="{ 'switch__rigth-pos': is_show_logs }"></div>
        </div>
      </div>
      <div class="right">
        <button
          *ngIf="!is_show_logs"
          type="button"
          class="btn btn-primary"
          (click)="is_show_canceled = !is_show_canceled"
        >
          {{ is_show_canceled ? 'Hide canceled' : 'Show canceled' }}
        </button>
      </div>
    </div>

    <div class="sn-panel__body statuses">
      <div [hidden]="is_show_logs">
        <div class="statuses__header">
          <span class="truncate statuses__name" title="Name">Name</span>
          <span class="truncate statuses__sent-to" title="Sent To">Sent To</span>
          <span class="truncate statuses__status" title="Status">Status</span>
          <span class="truncate statuses__date-sent" title="Date Sent">Date Sent</span>
          <span class="truncate statuses__date-signed" title="Date Signed">Date Signed</span>
          <span class="truncate statuses__exp" title="Expiration">Expiration</span>
          <span class="truncate statuses__actions" title="Actions">Actions</span>
        </div>

        <div class="statuses__list">
          <ng-container *ngFor="let status of statuses">
            <!--list of group invites-->
            <ng-container *ngIf="status.is_group">
              <div class="statuses__group" *ngIf="status.group_canceled == false || is_show_canceled">
                <div class="statuses__group-row">
                  <div class="statuses__group-name">
                    <span *ngIf="status.group_canceled == false || is_show_canceled">{{
                      status.group_name
                    }}</span>
                  </div>
                  <div class="statuses__actions" title="Actions">
                    <div *ngIf="status.valid == true">
                      <sn-dropdown-list
                        [commonParent]="snPanel"
                        [data]="status"
                        [optionsList]="[{ actionName: 'cancel_group_invite', title: 'Cancel Group Invite' }]"
                        (clickHandler)="actionHandler($event)"
                      >
                      </sn-dropdown-list>
                    </div>
                  </div>
                </div>

                <ng-container *ngFor="let document_status of status.document_status">
                  <sn-invite-status
                    [status]="document_status"
                    [isGroup]="true"
                    [isShow]="
                      document_status.status !== 'canceled' ||
                      (document_status.status === 'canceled' && is_show_canceled)
                    "
                    (showPushedLogE)="showPushedbackLog($event)"
                  >
                    <ng-container class="sn-invite-status-actions">
                      <ng-container
                        *ngIf="
                          document_status.valid_token == true &&
                          document_status.status === 'fulfilled' &&
                          document_status.status !== 'canceled'
                        "
                      >
                        <sn-dropdown-list
                          [commonParent]="snPanel"
                          [data]="status"
                          [width]="'200px'"
                          [optionsList]="[
                            { actionName: 'download', title: 'Download Signed Document' },
                            {
                              actionName: 'download_with_history',
                              title: 'Download Signed Document with Audit History'
                            }
                          ]"
                          (clickHandler)="actionHandler($event)"
                        >
                        </sn-dropdown-list>
                      </ng-container>
                    </ng-container>
                  </sn-invite-status>
                </ng-container>
              </div>
            </ng-container>
            <!--end list of group invites-->

            <!--list of none group invites-->
            <ng-container *ngIf="!status.is_group">
              <sn-invite-status
                [status]="status"
                [isShow]="status.status !== 'canceled' || (status.status === 'canceled' && is_show_canceled)"
                (showPushedLogE)="showPushedbackLog($event)"
              >
                <ng-container class="sn-invite-status-actions">
                  <ng-container
                    *ngIf="
                      status.valid_token == true &&
                      status.status !== 'fulfilled' &&
                      status.status !== 'canceled' &&
                      !status.is_signing_link
                    "
                  >
                    <sn-dropdown-list
                      [commonParent]="snPanel"
                      [data]="status"
                      [optionsList]="[
                        { actionName: 'replace_signer', title: 'Replace Signer' },
                        { actionName: 'advance_settings', title: 'Advanced Settings' },
                        { actionName: 'cancel_invite', title: 'Cancel Invite' }
                      ]"
                      (clickHandler)="actionHandler($event)"
                    >
                    </sn-dropdown-list>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      status.valid_token == true &&
                      status.status === 'fulfilled' &&
                      status.status !== 'canceled'
                    "
                  >
                    <sn-dropdown-list
                      [commonParent]="snPanel"
                      [data]="status"
                      [width]="'200px'"
                      [optionsList]="[
                        { actionName: 'download', title: 'Download Signed Document' },
                        {
                          actionName: 'download_with_history',
                          title: 'Download Signed Document with Audit History'
                        }
                      ]"
                      (clickHandler)="actionHandler($event)"
                    >
                    </sn-dropdown-list>
                  </ng-container>
                </ng-container>
              </sn-invite-status>
            </ng-container>
            <!--end list of none group invites-->
          </ng-container>
        </div>
      </div>

      <sn-invite-logs [logs]="logs" [isShowLogs]="is_show_logs"></sn-invite-logs>
    </div>
  </section>
</ng-container>

<sn-modal-popup [isShowModal]="display_replace_signer_modal">
  <ng-container class="sn-modal-header">
    <h2 class="slds-text-heading_medium slds-hyphenate">Replace Signer</h2>
  </ng-container>

  <ng-container class="sn-modal-content">
    <div class="signer">
      <p class="signer__text signer__notice">
        Note! The invite is canceled if you enter an email address that doesn't exist.
      </p>
      <div
        class="signer__row"
        *ngFor="let field_invite of selected_option_document_field_invites; let idx = index"
      >
        <label for="inputEmail-{{ idx }}" class="signer__label truncate" [attr.title]="field_invite.role">{{
          field_invite.role
        }}</label>
        <input
          type="text"
          class="sn-input signer__input"
          id="inputEmail-{{ idx }}"
          [(ngModel)]="field_invite.email"
        />
      </div>
    </div>
  </ng-container>

  <ng-container class="sn-modal-footer">
    <button class="btn btn-primary" (click)="updateReplaceSigners()">Submit</button>
    <button class="btn btn-neutral" (click)="hideAllModals()">Cancel</button>
  </ng-container>
</sn-modal-popup>

<sn-modal-popup [isShowModal]="display_advance_settings_modal">
  <ng-container class="sn-modal-header">
    <h2 id="modal-heading-01" class="slds-text-heading_medium slds-hyphenate">Advanced Settings</h2>
  </ng-container>
  <ng-container class="sn-modal-content">
    <!-- Select from list of roles which one user wants to update settings on -->
    <ng-container *ngIf="!advance_settings_role_selected">
      <div class="advance-table">
        <div class="advance-table__header">
          <span class="advance-table__role" title="Name">Role</span>
          <span class="advance-table__email" title="Created On">Email</span>
          <span class="advance-table__actions" title="Actions">Action</span>
        </div>

        <div class="advance-table__list">
          <ng-container *ngFor="let field_invite of selected_option_document_field_invites">
            <div class="advance-table__row">
              <div class="advance-table__role truncate" [attr.title]="field_invite.role">
                {{ field_invite.role }}
              </div>
              <div class="advance-table__email truncate" [attr.title]="field_invite.email">
                {{ field_invite.email }}
              </div>
              <div class="advance-table__actions">
                <button
                  type="submit"
                  class="btn btn-primary"
                  (click)="roleSelectedForAdvanceSettings(field_invite)"
                >
                  Select
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="advance_settings_role_selected">
      <div class="advance-panel">
        <strong class="advance-panel__title">
          Update for role "{{ selected_advance_settings_field_invite.role }}" sent to "{{
            selected_advance_settings_field_invite.email
          }}"
        </strong>
        <!--<br>-->
        <div class="advance-panel__content sn-form">
          <div class="sn-form__row">
            <div class="sn-form__group sn-form__half-row">
              <label class="form-group__label" for="password">Password</label>
              <div class="form-group__control">
                <input
                  class="sn-sf-input"
                  id="password"
                  name="password"
                  type="password"
                  placeholder="***********"
                  [(ngModel)]="new_password"
                />
                <span class="advance-panel__text">
                  The value in the field does not reflect the current password. Setting a new value will
                  update the invite with a new password.
                </span>
              </div>
            </div>

            <div class="sn-form__group sn-form__half-row">
              <label class="form-group__label" for="reminder">Reminder</label>
              <div class="form-group__control">
                <input
                  class="sn-sf-input"
                  id="reminder"
                  name="reminder"
                  type="number"
                  [(ngModel)]="selected_advance_settings_field_invite.reminder"
                />
                <span class="advance-panel__text">
                  The value does not reflect the current number of days. Setting this value will update the
                  invite with the new reminder days number.
                </span>
              </div>
            </div>
          </div>

          <div class="sn-form__row">
            <div class="sn-form__group sn-form__half-row">
              <label class="form-group__label" for="expiration">Expiration Days</label>
              <div class="form-group__control">
                <input
                  class="sn-sf-input"
                  id="expiration"
                  name="expiration"
                  type="number"
                  [(ngModel)]="selected_advance_settings_field_invite.expiration_time"
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-group__label">
              <input
                type="checkbox"
                name="allow-forwarding"
                class="slds-checkbox"
                [(ngModel)]="selected_advance_settings_field_invite.reassign"
                [attr.checked]="selected_advance_settings_field_invite.reassign === true"
              />
              <span>Allow Forwarding</span>
            </label>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container class="sn-modal-footer">
    <button class="btn btn-neutral" (click)="hideAllModals()">Cancel</button>
    <button class="btn btn-primary" *ngIf="advance_settings_role_selected" (click)="updateAdvanceSettings()">
      Submit
    </button>
  </ng-container>
</sn-modal-popup>

<sn-modal-popup
  [isShowModal]="isPushedbackLogOpen && (currentPushedbackLog.errorType || currentPushedbackLog.fieldsData)"
>
  <ng-container class="sn-modal-header">
    <h2 class="slds-text-heading_medium slds-hyphenate">Pushedback Log</h2>
  </ng-container>
  <ng-container class="sn-modal-content">
    <div class="slds-modal__content-item pushback-error__header">
      <p
        class="pushback-error__message"
        *ngIf="currentPushedbackLog.errorMessage || currentPushedbackLog.message"
      >
        <b>Error message:</b> {{ currentPushedbackLog.errorMessage || currentPushedbackLog.message }}
      </p>
      <p class="pushback-error__message">
        Check the availability of the following fields for your object.
        <br />
        Confirm the field values from SignNow document are correct for your object fields.
      </p>
    </div>
    <div class="slds-modal__content-item pushback-error__table">
      <div class="pushback-error__row">
        <span class="pushback-error__column pushback-error__column_head">API field name</span>
        <span class="pushback-error__column pushback-error__column_head">Error type</span>
        <span class="pushback-error__column pushback-error__column_head">Error message</span>
      </div>
      <div class="pushback-error__row" *ngFor="let fieldsDataItem of currentPushedbackLog.fieldsData">
        <span class="pushback-error__column">{{ fieldsDataItem.fieldName }}</span>
        <span class="pushback-error__column">{{ fieldsDataItem.errorType }}</span>
        <span class="pushback-error__column">{{ fieldsDataItem.errorMessage }}</span>
        <!--<span class="pushback-error__column" *ngIf="fieldsDataItem.errorMessage">{{ fieldsDataItem.errorMessage }}</span>-->
      </div>
    </div>
  </ng-container>
  <ng-container class="sn-modal-footer">
    <button class="btn btn-neutral" (click)="isPushedbackLogOpen = false">Close</button>
  </ng-container>
</sn-modal-popup>
